import React from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import CancelOutlinedIcon from '@mui/icons-material/CancelOutlined';
import { Grid, IconButton, List, ListItem, Typography } from '@mui/material';
import CustomModal from '../CustomModal';
import NotificationRow from './NotificationRow';

function NotificationsModal({ isOpen, handleClose }) {
  const { notifications } = useSelector((store) => store.notifications);

  const groupedNotifications = React.useMemo(() => {
    const groups = new Map();
    // Filter out read notifications - only show unread ones
    const unreadNotifications = (notifications || []).filter((n) => !n.read);

    unreadNotifications.forEach((n) => {
      const key = `${n.short_title || ''}|${n.message || ''}`;
      if (!groups.has(key)) {
        groups.set(key, {
          representative: n,
          ids: [n.id],
        });
      } else {
        const entry = groups.get(key);
        entry.ids.push(n.id);
      }
    });
    return Array.from(groups.values()).map((g) => ({
      notification: g.representative,
      ids: g.ids,
      count: g.ids.length,
    }));
  }, [notifications]);

  return (
    <CustomModal isOpen={isOpen} handleClose={handleClose}>
      <Grid container justifyContent="center" rowGap={1}>
        <Grid item xs={12}>
          <IconButton onClick={handleClose}>
            <CancelOutlinedIcon sx={{ fill: '#0997ba' }} />
          </IconButton>
        </Grid>
        <Grid item xs={12} textAlign="center">
          <Typography variant="body1" sx={{ fontWeight: 700 }}>
            Notifications
          </Typography>
        </Grid>
        <Grid item xs={12} mt={2} maxHeight="50vh" overflow="auto">
          <List>
            {groupedNotifications.length > 0 ? (
              groupedNotifications.map(({ notification, ids, count }) => (
                <ListItem key={ids[0]}>
                  <NotificationRow
                    notification={notification}
                    groupedIds={ids}
                    groupCount={count}
                  />
                </ListItem>
              ))
            ) : (
              <ListItem>
                <Typography
                  variant="body2"
                  color="text.secondary"
                  sx={{ width: '100%', textAlign: 'center' }}>
                  No new notifications
                </Typography>
              </ListItem>
            )}
          </List>
        </Grid>
      </Grid>
    </CustomModal>
  );
}

NotificationsModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
};

export default NotificationsModal;
